import { RiFireFill } from '@remixicon/react'
import clsx from 'clsx'
import i18n from 'src/i18n'
import { TrendingPostTagProps } from './trendingPostTag.types'

const TrendingPostTag = ({ className }: TrendingPostTagProps) => {
  return (
    <span className={clsx(className, '_d-flex _align-items-center _text-1 _text-red-light')}>
      <RiFireFill size={12} className="_mr-1" /> {i18n.t('trending_posts.featured_tag')}
    </span>
  )
}

export default TrendingPostTag
